import { useContext } from "react";
import { LoadingContext } from "./LoadingContext";
var useLoader = function () {
    var _a = useContext(LoadingContext), isLoading = _a.isLoading, setIsLoading = _a.setIsLoading;
    return {
        isLoading: isLoading,
        startLoader: function () { return setIsLoading(true); },
        stopLoader: function () { return setIsLoading(false); },
    };
};
export default useLoader;
